module.exports = __webpack_public_path__ + "images/aef408d9ec0ae876f8b1746377a951df-mammoth_lakes.png";